/**
 * The frame every Followers tab shares (ISSUE-1372): skeleton rows while the
 * first read is in flight, the empty state, the bordered list, and Show
 * more. Each tab supplies only its rows.
 */
import { Button, Skeleton } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { SectionEmptyState } from "../../shell/SectionScreen";
import { SHOW_MORE_LABEL } from "./followCopy";

export type typeFollowListFrameProps = {
  isLoading: boolean;
  isEmpty: boolean;
  emptyHeadline: string;
  emptyBody: string;
  canShowMore: boolean;
  onShowMore: () => void;
  isShowingMore: boolean;
  testId: string;
  children: ReactNode;
};

export const FollowListFrame = (props: typeFollowListFrameProps): ReactNode => {
  if (props.isLoading) {
    return (
      <div
        className="flex flex-col gap-2"
        data-testid={`${props.testId}-loading`}
      >
        <Skeleton shape="text" />
        <Skeleton shape="text" />
        <Skeleton shape="text" />
      </div>
    );
  }
  if (props.isEmpty) {
    return (
      <div data-testid={`${props.testId}-empty`}>
        <SectionEmptyState
          headline={props.emptyHeadline}
          body={props.emptyBody}
        />
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-4" data-testid={props.testId}>
      {props.children}
      {props.canShowMore ? (
        <Button
          variant="secondary"
          loading={props.isShowingMore}
          loadingLabel="Loading more"
          onClick={props.onShowMore}
          data-testid={`${props.testId}-show-more`}
        >
          {SHOW_MORE_LABEL}
        </Button>
      ) : null}
    </div>
  );
};

export const FOLLOW_LIST_CLASS =
  "flex flex-col divide-y divide-line rounded-lg border border-line bg-surface";
